import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {subjects as S, permissionTypes as T} from '../../../_common/constants/permissionSubjects';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {can} from '../../../_common/components/Permissions';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import ModalHeader from '../../../_common/components/ModalHeader';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';
import {usePopupCreateOrderContext} from "../PopupCreateOrderContext";

export type PopupCreateOrderProps = {
  orderID: number;
}

const PopupCreateOrder = ({orderID}: PopupCreateOrderProps) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const {formatMessage} = useIntl();
  const {handleCreateOrder, gotLines} = usePopupCreateOrderContext();
  const popupMessage = formatMessage({
    id: 'price-quotes-page-popup-message-createOrder',
    defaultMessage: 'Are you sure? This will automatically create the order and, if available, the reports.'
  });

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'cancel'}
        title={TTS.CREATE_ORDER}
        disabled={!can(T.FULL, S.PRICE_QUOTES_PAGE) || !!orderID || !gotLines}
        onClick={() => handleShowModal()}
        label={<img src={toAbsoluteUrl('media/common/Create-document.svg')} alt="create"/>}
        customClassnames={'mx-2'}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
        <>
          <ModalHeader header={popupMessage}/>
          <ModalButtonsContainer customClassnames={largeButtonsPadding}>
            <ButtonAction
              variant={'cancel'}
              onClick={handleCloseModal}
              label={formatMessage({id: 'no', defaultMessage: 'No'})}
              customClassnames={buttonCancel}
            />
            <ButtonAction
              onClick={handleCreateOrder}
              useIcon={'/media/common/Check-in-circle_white.svg'}
              label={formatMessage({id: 'yes', defaultMessage: 'Yes'})}
              customClassnames={buttonSubmit}
            />
          </ModalButtonsContainer>
        </>
      </ModalContainer>
    </>
  );
};

export default PopupCreateOrder;